import firebase from '@firebase/app';
import '@firebase/storage';

export default {
	ref(path) {
        return firebase.database().ref(path)
    },
    storage() {
        return firebase.storage();
    },
    timestamp() {
        return firebase.database.ServerValue.TIMESTAMP
    }
}
